import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { CartProvider } from "./hooks/useCart";
import { MemberProvider } from "./hooks/useMember";
import Navbar from "./components/feature/Navbar";
import Breadcrumb from "./components/feature/Breadcrumb";
import Footer from "./components/feature/Footer";

function LayoutWrapper() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  if (isLoginPage) {
    return <AppRoutes />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-background-100">
      <Navbar />
      <Breadcrumb />
      <main className="flex-1 min-w-0 flex flex-col">
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <MemberProvider>
          <LayoutWrapper />
        </MemberProvider>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;